export default "__VITE_ASSET__0657b61b__"